// carousel.js — Datafusion Agency Hero Carousel
(function () {
  class DFCarousel {
    constructor(el) {
      this.el = el;
      this.slides = [...el.querySelectorAll('.df-hero__slide')];
      this.dots = [...el.querySelectorAll('.df-hero__dot')];
      this.cur = 0;
      this.total = this.slides.length;
      this.timer = null;

      el.querySelector('.df-hero__arrow--prev')?.addEventListener('click', () => this.go(this.cur - 1));
      el.querySelector('.df-hero__arrow--next')?.addEventListener('click', () => this.go(this.cur + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.startTimer();
    }

    go(idx) {
      this.slides[this.cur].classList.remove('is-active');
      this.dots[this.cur]?.classList.remove('is-active');
      this.cur = ((idx % this.total) + this.total) % this.total;
      this.slides[this.cur].classList.add('is-active');
      this.dots[this.cur]?.classList.add('is-active');
      this.resetTimer();
    }

    startTimer() {
      this.timer = setInterval(() => this.go(this.cur + 1), 5000);
    }

    resetTimer() {
      clearInterval(this.timer);
      this.startTimer();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.df-hero').forEach(el => new DFCarousel(el));
  });
})();
